import { render } from "./AVR.vue?vue&type=template&id=26145e02"
import script from "./AVR.vue?vue&type=script&lang=js"
export * from "./AVR.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__